@if (parentFormGroup) {
  <ng-container [formGroup]="parentFormGroup">
    <div
      class="flex-wrap position-relative main-div"
      [ngClass]="{ 'mt-3': currentConfig?.control?.controls?.length === 0 }"
    >
      <div
        class="d-flex ms-3 position-absolute dynamic-list-title"
        [title]="currentConfig.displayText || currentConfig.property"
        [ngClass]="{
          'no-controls-title': currentConfig?.control?.controls?.length === 0,
        }"
      >
        {{ currentConfig.displayText || currentConfig.property
        }}{{ currentConfig?.validators?.required ? " *" : "" }}
        <ra-tooltip [tooltipConfig]="currentConfig?.tooltipConfig"></ra-tooltip>
      </div>
      <div
        [formArrayName]="currentConfig?.property"
        cdkDropList
        [cdkDropListDisabled]="readOnly || !currentConfig?.reorderable"
        (cdkDropListDropped)="drop($event)"
        [ngClass]="{ 'reorderable-list': currentConfig?.reorderable }"
      >
        @for (
          control of currentConfig?.control?.controls;
          track control;
          let i = $index
        ) {
          <div
            class="mb-2 dynamic-list-controls dynamic-list-parent-div d-flex flex-row align-items-center me-2"
            cdkDrag
            [cdkDragDisabled]="readOnly || !currentConfig?.reorderable"
            cdkDragLockAxis="y"
          >
            @if (currentConfig?.reorderable && !readOnly) {
              <i class="drag-handle fa fa-grip-vertical" cdkDragHandle></i>
            }
            <div class="select-wrapper">
              @if (showSpinnerForDropdown) {
                <div class="select-spinner-overlay">
                  <mat-spinner diameter="28"></mat-spinner>
                </div>
              }
              <mat-form-field
                class="dynamic-list"
                [ngClass]="{
                  'multi-select': currentConfig?.dictKeyConfig?.isMultiSelect,
                  'disabled-look': readOnly,
                }"
              >
                @if (!currentConfig?.dictKeyConfig) {
                  <input
                    [readonly]="readOnly"
                    [ngClass]="{ 'read-only': readOnly }"
                    matInput
                    [formControlName]="i"
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  UiControlType.Text
                ) {
                  <input
                    [readonly]="readOnly"
                    [ngClass]="{ 'read-only': readOnly }"
                    matInput
                    [formControlName]="i"
                    [mask]="currentConfig?.dictKeyConfig?.mask"
                    [thousandSeparator]="
                      currentConfig?.dictKeyConfig?.thousandSeparator
                    "
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  UiControlType.Number
                ) {
                  <input
                    [readonly]="readOnly"
                    [ngClass]="{ 'read-only': readOnly }"
                    matInput
                    type="number"
                    [formControlName]="i"
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  UiControlType.Dropdown
                ) {
                  <mat-select
                    [disableOptionCentering]="true"
                    [formControlName]="i"
                    (opened)="
                      getDropdownValues(currentConfig?.dictKeyConfig);
                      filterCtrl.setValue('')
                    "
                    [title]="
                      getSelectedValueTitle(
                        getValueFormControl(i),
                        currentConfig
                      )
                    "
                    [multiple]="!!currentConfig?.dictKeyConfig?.isMultiSelect"
                    [ngClass]="{
                      'read-only':
                        readOnly ||
                        currentConfig?.orderOnly ||
                        currentConfig?.readOnly,
                    }"
                  >
                    <mat-select-trigger>
                      @if (showSpinnerForDropdown) {
                        <mat-spinner [diameter]="25"></mat-spinner>
                      } @else {
                        <div class="selected-values">
                          @for (
                            value of getSelectedValueTitle(
                              getValueFormControl(i),
                              currentConfig?.dictKeyConfig
                            );
                            track $index
                          ) {
                            <span class="selected-value">{{ value }}</span>
                          }
                        </div>
                      }
                    </mat-select-trigger>
                    <mat-option>
                      <ngx-mat-select-search
                        placeholderLabel="Search..."
                        noEntriesFoundLabel="No search results"
                        [formControl]="filterCtrl"
                      ></ngx-mat-select-search>
                    </mat-option>
                    @if (currentConfig?.dictKeyConfig?.loading) {
                      <mat-option class="pointer-events-none dropdown-loading">
                        <mat-spinner [diameter]="25"></mat-spinner>
                      </mat-option>
                    }
                    @if (!readOnly) {
                      <mat-option>None</mat-option>
                    }
                    @for (value of filteredValues; track $index) {
                      <mat-option
                        [disabled]="readOnly"
                        [value]="
                          currentConfig?.dictKeyConfig.dropdownID
                            ? value[
                                currentConfig?.dictKeyConfig.dropdownID
                              ]?.toString()
                            : value?.toString()
                        "
                      >
                        {{
                          currentConfig?.dictKeyConfig.dropdownLabel
                            ? value[
                                currentConfig?.dictKeyConfig.dropdownLabel
                              ]?.toString()
                            : value?.toString()
                        }}
                      </mat-option>
                    }
                    <mat-option
                      style="height: 0; display: none"
                      [value]="control?.value"
                    >
                      {{ control?.value }}
                    </mat-option>
                  </mat-select>
                }
                <mat-error>
                  {{
                    currentConfig?.errorMessages?.[
                      keys(control?.errors)?.[0]
                    ] || "Please review the field"
                  }}
                </mat-error>
              </mat-form-field>
            </div>
            @if (!readOnly) {
              <div class="d-flex align-items-center gap-2 me-3 flex-shrink-0">
                <i
                  class="list-actions fa fa-plus"
                  (click)="addDynamicListValue(currentConfig.control)"
                ></i>
                <i
                  class="list-actions fa fa-trash-alt"
                  (click)="deleteDynamicListValue(currentConfig.control, i)"
                ></i>
              </div>
            }
            @if (parentFormGroup?.get(currentConfig.property)?.errors) {
              <mat-error class="custom-mat-error mt-1">
                {{
                  currentConfig?.parentErrorMessages?.[
                    keys(
                      parentFormGroup?.get(currentConfig.property)?.errors
                    )?.[0]
                  ] || "Please review the field"
                }}
              </mat-error>
            }
          </div>
        }
        @if (currentConfig?.control?.controls?.length === 0) {
          <i
            class="py-3 px-3 fa add-new"
            [ngClass]="{ 'read-only': readOnly }"
            (click)="addDynamicListValue(currentConfig.control)"
            >Add New <i class="fa fa-plus-circle"></i
          ></i>
        }
      </div>
    </div>
  </ng-container>
}
